export const departmentsDatas = [
  'Sales',
  'Marketing',
  'Engineering',
  'Human ressources',
  'Legal',
]
